import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'antd';
import usePatientPolicies from '@hooks/usePatientPolicies';
import { useRegistrationFormInstance } from '@components/Patients/Registration/useSelfRegistrationFormInstance';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';

export const TermsCheckboxFormItem = (props: RegistrationFormItemProps) => {
  const { t } = useTranslation('common');
  const [accepted, setAccepted] = useState(false);

  const form = useRegistrationFormInstance();
  const policies = usePatientPolicies();

  return (
    <RegistrationFormItem
      name="checkbox"
      required
      validateTrigger="onBlur"
      rules={[
        {
          validator: (_, __, callback) => {
            if (accepted) {
              return callback();
            }
            return callback('Please accept the terms and conditions');
          }
        }
      ]}
      getValueProps={(value) => ({
        checked: value
      })}
      {...props}
    >
      <Checkbox
        checked={accepted}
        onChange={(v) => {
          setAccepted(v.target.checked);
          form.setFieldValue('checkbox', v.target.checked);
        }}
        data-testid="terms-and-conditions-acknowledged"
      >
        {policies
          ?.filter((p) => p.policy_level === 'S')
          .map((p) => {
            if (p.policy_link) {
              return (
                <div key={p.policy_code} dangerouslySetInnerHTML={{ __html: addTargetBlankToLinks(p.policy_link) }} />
              );
            }

            return (
              <div key={p.policy_code}>
                {t('I accept the')}{' '}
                <a rel="noreferrer" href={`/patients/legal/?all_policies=0&activeTab=${p.policy_code}`} target="_blank">
                  {p.description}
                </a>
              </div>
            );
          })}
      </Checkbox>
    </RegistrationFormItem>
  );
};

function addTargetBlankToLinks(html: string) {
  if (typeof window === 'undefined') return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const links = doc.querySelectorAll('a');

  for (const link of links) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noreferrer');
  }

  return doc.body.innerHTML;
}
